import { z } from 'zod';

import authService from './auth/auth';
import { DjangoDataZodSchema } from './common';
import { apiRoutes } from './config';

const applicationWebhookSchema = z.object({
  id: z.number(),
  name: z.string(),
  url: z.string(),
  isActive: z.boolean(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type ApplicationWebhook = z.infer<typeof applicationWebhookSchema>;

const applicationWebhookWithSecretSchema = applicationWebhookSchema.extend({
  secret: z.string(),
});

const webhookTestResultSchema = z.object({
  success: z.boolean(),
  statusCode: z.number().nullable(),
});

export type ApplicationWebhookPayload = Pick<
  ApplicationWebhook,
  'name' | 'url' | 'isActive'
>;

export const getApplicationWebhooks = async () => {
  const { data } = await authService.get(apiRoutes.applicationWebhooks._root, {
    params: { limit: 999 },
  });
  return DjangoDataZodSchema(applicationWebhookSchema).parse(data);
};

export const postApplicationWebhook = async (
  payload: ApplicationWebhookPayload
) => {
  const { data } = await authService.post(
    apiRoutes.applicationWebhooks._root,
    payload
  );
  return applicationWebhookWithSecretSchema.parse(data);
};

export const patchApplicationWebhook = async ({
  id,
  ...payload
}: Partial<ApplicationWebhookPayload> & { id: number }) => {
  const { data } = await authService.patch(
    apiRoutes.applicationWebhooks.detail(id)._root,
    payload
  );
  return applicationWebhookSchema.parse(data);
};

export const deleteApplicationWebhook = async (id: number) => {
  return authService.delete(apiRoutes.applicationWebhooks.detail(id)._root);
};

export const rotateApplicationWebhookSecret = async (id: number) => {
  const { data } = await authService.post(
    apiRoutes.applicationWebhooks.detail(id).rotateSecret
  );
  return applicationWebhookWithSecretSchema.parse(data);
};

export const testApplicationWebhook = async (id: number) => {
  const { data } = await authService.post(
    apiRoutes.applicationWebhooks.detail(id).test
  );
  return webhookTestResultSchema.parse(data);
};
